/* eslint-disable camelcase */
import {
  isTMA,
  type LaunchParams,
  mockTelegramEnv,
  parseInitData,
  retrieveLaunchParams,
} from "@telegram-apps/sdk-react"
import { useEffect } from "react"

/**
 * Mocks Telegram environment in development mode.
 */
export function useTelegramMock(): void {
  useEffect(() => {
    if (!sessionStorage.getItem("env-mocked") && isTMA("simple")) {
      return
    }

    // Determine which launch params should be applied. We could already
    // apply them previously, or they may be specified on purpose using the
    // default launch parameters transmission method.
    let lp: LaunchParams | undefined
    try {
      lp = retrieveLaunchParams()
    } catch (_) {
      const initDataRaw = new URLSearchParams([
        [
          "user",
          JSON.stringify({
            id: process.env.NEXT_PUBLIC_TG_ID!,
            first_name: "0xCucu",
            last_name: "",
            username: "Cucu0x",
            language_code: "en",
            is_premium: true,
            allows_write_to_pm: true,
            photo_url:
              "https:\\/\\/t.me\\/i\\/userpic\\/320\\/8k2cJRag62uLStWxKwV8mYv8jv-F5HlLorkIgSwDcd221NiD9DL6PBe8yQ1G6zDO.svg",
          }),
        ],
        ["hash", process.env.NEXT_PUBLIC_TG_HASH!],
        ["auth_date", "1737995419"],
        ["start_param", "debug"],
        ["chat_type", "sender"],
        ["chat_instance", "7463872946339568432"],
        ["signature", process.env.NEXT_PUBLIC_TG_SIGNATURE!],
      ]).toString()

      lp = {
        themeParams: {
          accentTextColor: "#6ab2f2",
          bgColor: "#17212b",
          buttonColor: "#5288c1",
          buttonTextColor: "#ffffff",
          destructiveTextColor: "#ec3942",
          headerBgColor: "#17212b",
          hintColor: "#708499",
          linkColor: "#6ab3f3",
          secondaryBgColor: "#232e3c",
          sectionBgColor: "#17212b",
          sectionHeaderTextColor: "#6ab3f3",
          subtitleTextColor: "#708499",
          textColor: "#f5f5f5",
        },
        initData: parseInitData(initDataRaw),
        initDataRaw,
        version: "8",
        platform: "tdesktop",
      }
    }

    sessionStorage.setItem("env-mocked", "1")
    mockTelegramEnv(lp)
    console.warn(
      "⚠️ As long as the current environment was not considered as the Telegram-based one, it was mocked. Take a note, that you should not do it in production and current behavior is only specific to the development process. Environment mocking is also applied only in development mode. So, after building the application, you will not see this behavior and related warning, leading to crashing the application outside Telegram.",
    )
  }, [])
}
